import { CountryFlag, Flex, Text } from '@applyboard/crystal-ui';
import { Copyable } from "../../../../components/Copyable";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { jsxs as _jsxs } from "@emotion/react/jsx-runtime";
var countryName = new Intl.DisplayNames(['en'], {
  type: 'region'
});
export var LabelledFlag = function LabelledFlag(props) {
  return _jsxs(Flex, {
    direction: "row",
    gap: 2,
    children: [_jsx(CountryFlag, {
      countryCode: props.countryCode
    }), _jsx(Text, {
      variant: "bodyM",
      children: _jsx(Copyable, {
        disabled: !props.copyEnabled,
        children: countryName.of(props.countryCode)
      })
    })]
  });
};